import React, { useState, useEffect } from "react";
import styles from "./ProductActivity.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import Item from "./Item";
import { getCommercialActivityData } from "../../../services/prospectDashboard.service";

const ProductActivity = ({ className, commercialActivityData }) => {
  const intervals = ["Tous les commerciaux"];
  const [activeTab, setActiveTab] = useState(intervals[0]);
  const [data, setData] = useState({ commercials: [], totals: {} });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Si les données sont passées en props, les utiliser
        if (commercialActivityData) {
          console.log('Données commerciales reçues en props:', commercialActivityData);
          setData(commercialActivityData);
          setError(null);
        } else {
          // Sinon, récupérer les données via l'API
          console.log('Récupération des données commerciales via API...');
          const result = await getCommercialActivityData();
          console.log('Résultat API commerciaux:', result);
          setData(result);
          setError(null);
        }
      } catch (err) {
        console.error("Failed to fetch commercial activity data:", err);
        setError("Impossible de charger les données d'activité commerciale.");
        setData({ commercials: [], totals: {} });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [commercialActivityData]);

  // Filtrer les commerciaux selon l'onglet actif
  const getFilteredCommercials = () => {

    return data.commercials;
  };

  return (
    <Card
      className={cn(styles.card, className)}
      title="Activité"
      classTitle="title-green"
    >
      {loading && <p>Chargement des données d'activité...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && (
        <>
          <div className={styles.table}>
            <div className={styles.row}>
              <div className={styles.col}>Commercial</div>
              <div className={styles.col}>Étudiants</div>
              <div className={styles.col}>Entreprises</div>
              <div className={styles.col}>Offres</div>
            </div>
            {getFilteredCommercials().map((commercial, index) => (
              <div className={styles.row} key={commercial.id}>
                <div className={styles.col}>
                  <div className={styles.label}>Nom</div>
                  <div className={styles.name}>
                    {commercial.name}
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.label}>Étudiants</div>
                  <Item 
                    className={styles.item} 
                    item={{
                      counter: commercial.students,
                      color: "#2A85FF"
                    }} 
                  />
                </div>
                <div className={styles.col}>
                  <div className={styles.label}>Entreprises</div>
                  <Item 
                    className={styles.item} 
                    item={{
                      counter: commercial.companies,
                      color: "#B5E4CA"
                    }} 
                  />
                </div>
                <div className={styles.col}>
                  <div className={styles.label}>Offres</div>
                  <Item 
                    className={styles.item} 
                    item={{
                      counter: commercial.offers,
                      color: "#B1E5FC"
                    }} 
                  />
                </div>
              </div>
            ))}
          </div>
          {getFilteredCommercials().length === 0 && (
            <div className={styles.empty}>
              <p>Aucun commercial trouvé.</p>
            </div>
          )}
          <div className={styles.nav}>
            {intervals.map((x, index) => (
              <button
                className={cn(styles.link, {
                  [styles.active]: x === activeTab,
                })}
                onClick={() => setActiveTab(x)}
                key={index}
              >
                {x}
              </button>
            ))}
          </div>
        </>
      )}
    </Card>
  );
};

export default ProductActivity;
